// Third party imports
import { combineReducers, configureStore } from "@reduxjs/toolkit";

import clientBoardSlice from "./slices/clientBoardSlice.jsx";
import companiesSlice from "./slices/companiesSlice.jsx";
import filtersManagerSlice from "./slices/filtersManagerSlice.jsx";
import notificationsSlice from "./slices/notificationsSlice.jsx";
import profileSlice from "./slices/profileSlice.jsx";
import snackbarSlice from "./slices/snackbarSlice.jsx";
import stastsSlice from "./slices/statsSlice.jsx";
import teamsSlice from "./slices/teamsSlice.jsx";
import userAuthSlice from "./slices/userAuth";
import operatorsSlice from "./slices/operatorsSlice.jsx";
import notesSlice from "./slices/notesSlice.jsx";
import uploadSlice from "./slices/uploadSlice.jsx";
import announcementsSlice from "./slices/announcementsSlice.jsx";
import credentialsSlice from "./slices/credentialsSlice.jsx";
import serviceTypesSlice from "./slices/serviceTypesSlice.jsx";
import subServiceTypesSlice from "./slices/subServiceTypesSlice.jsx";
import subServiceItemsSlice from "./slices/subServiceItemsSlice.jsx";
import rolesSlice from "./slices/rolesSlice.jsx";
import myBoardSlice from "./slices/myBoardSlice.jsx";
import miscSlice from "./slices/miscSlice.jsx";
import archiveSlice from "./slices/archiveSlice.jsx";
import labelsSlice from "./slices/labelsSlice.jsx";
import paymentsSlice from "./slices/paymentsSlice.jsx";
import teamBoardSlice from "./slices/teamBoardSlice.jsx";
import boardsSlice from "./slices/boardsSlice.jsx";
import linkedBoardSlice from "./slices/linkedBoardSlice.jsx";

const appReducer = combineReducers({
  userAuth: userAuthSlice,
  snackbar: snackbarSlice,
  notifications: notificationsSlice,
  profile: profileSlice,
  companies: companiesSlice,
  stats: stastsSlice,
  filtersManager: filtersManagerSlice,
  teams: teamsSlice,
  clientBoard: clientBoardSlice,
  operators: operatorsSlice,
  notes: notesSlice,
  upload: uploadSlice,
  announcements: announcementsSlice,
  credentials: credentialsSlice,
  serviceTypes: serviceTypesSlice,
  subServiceTypes: subServiceTypesSlice,
  subServiceItems: subServiceItemsSlice,
  roles: rolesSlice,
  myBoard: myBoardSlice,
  labels: labelsSlice,
  misc: miscSlice,
  archive: archiveSlice,
  payments: paymentsSlice,
  teamBoard: teamBoardSlice,
  boards: boardsSlice,
  linkedBoard: linkedBoardSlice,
});
const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    const { filters } = state;
    state = { filters };
  }
  return appReducer(state, action);
};

export default configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: true,
});
